import { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ExportAllData = () => {
  const { t, i18n } = useTranslation();
  const cips = useSelector((state) => state.cips);
  const cleaningEffectiness = useSelector((state) => state.cleaningEffectiness);
  const fouling = useSelector((state) => state.fouling);
  const flow = useSelector((state) => state.flow);
  const pressure = useSelector((state) => state.pressure);
  const water_type = useSelector((state) => state.water_type);
  const feed = useSelector((state) => state.feed_quality);
  const permeate = useSelector((state) => state.permeate_quality);
  const temperature = useSelector((state) => state.temperature);
  const flux = useSelector((state) => state.flux);
  const volume = useSelector((state) => state.volume);
  const currency = useSelector((state) => state.currency);
  const mass = useSelector((state) => state.mass);
  const conversion_rate = useSelector((state) => state.conversion_rate);
  const engryPrice = useSelector((state) => state.energyPrice);
  const cipAcidPrice = useSelector((state) => state.acidPrice);
  const cipAlkaliPrice = useSelector((state) => state.alkaliPrice);
  const cipWaterPrice = useSelector((state) => state.waterPrice);
  const costofDownTime = useSelector((state) => state.costofDownTime);
  const alkali_used_per_cip = useSelector((state) => state.alkali_used_per_cip);
  const acid_used_per_cip = useSelector((state) => state.acid_used_per_cip);
  const additional_chemical_price = useSelector(
    (state) => state.additional_chemical_price
  );
  const additional_chemical_per_cip = useSelector(
    (state) => state.additional_chemical_per_cip
  );
  const acid_cip_ph = useSelector((state) => state.acid_cip_ph);
  const alkali_cip_ph = useSelector((state) => state.alkali_cip_ph);
  const cip_solution_ph = useSelector((state) => state.cip_solution_ph);
  const acid_cip_temp = useSelector((state) => state.acid_cip_temp);
  const alkali_cip_temp = useSelector((state) => state.alkali_cip_temp);
  const cip_solution_temp = useSelector((state) => state.cip_solution_temp);
  const acid_cip_duration = useSelector((state) => state.acid_cip_duration);
  const alkali_cip_duration = useSelector((state) => state.alkali_cip_duration);
  const cip_solution_duration = useSelector(
    (state) => state.cip_solution_duration
  );
  const plantName = useSelector((state) => state.plantName);
  const plantLocation = useSelector((state) => state.plantLocation);
  const num_trains = useSelector((state) => state.num_trains);
  const dataset_name = useSelector((state) => state.dataset_name);
  const tol_num_elements = useSelector((state) => state.tol_num_elements);
  const is_dupont_element = useSelector((state) => state.is_dupont_element);
  const sel_pass = useSelector((state) => state.sel_pass);
  const sel_train = useSelector((state) => state.sel_train);
  const sel_stage = useSelector((state) => state.sel_stage);
  const sel_pressure_vessels = useSelector(
    (state) => state.sel_pressure_vessels
  );
  const sel_element_involved = useSelector(
    (state) => state.sel_element_involved
  );
  const sel_element_type = useSelector((state) => state.sel_element_type);
  const feed_water_factor = useSelector((state) => state.feed_water_factor);
  const feed_water_permeate_factor = useSelector(
    (state) => state.feed_water_permeate_factor
  );
  const clusterPoints = useSelector((state) => state.clusterPoints);
  const medianCurvePoints = useSelector((state) => state.medianCurvePoints);
  const maxRelativeDistance = useSelector((state) => state.maxRelativeDistance);
  const permeateFlowDropThreshold = useSelector(
    (state) => state.permeateFlowDropThreshold
  );
  const pressureDropThreshold = useSelector(
    (state) => state.pressureDropThreshold
  );
  const useSaltPassageChange = useSelector(
    (state) => state.useSaltPassageChange
  );
  const saltPassageIncreaseThreshold = useSelector(
    (state) => state.saltPassageIncreaseThreshold
  );
  const minDaysBetweenCIPs = useSelector((state) => state.minDaysBetweenCIPs);
  const maxDaysBetweenCIPs = useSelector((state) => state.maxDaysBetweenCIPs);
  const cipIdentificationResolution = useSelector(
    (state) => state.cipIdentificationResolution
  );
  const minIdleDaysShutdown = useSelector((state) => state.minIdleDaysShutdown);
  const maxStabilizationDaysAfterCIP = useSelector(
    (state) => state.maxStabilizationDaysAfterCIP
  );
  const minStabilizationDaysAfterCIP = useSelector(
    (state) => state.minStabilizationDaysAfterCIP
  );
  const minPointsForCleaningEffectiveness = useSelector(
    (state) => state.minPointsForCleaningEffectiveness
  );
  const deafultStabilizationDaysAfterCIP = useSelector(
    (state) => state.deafultStabilizationDaysAfterCIP
  );
  const foulingAggressivenessFactor = useSelector(
    (state) => state.foulingAggressivenessFactor
  );
  const numberOfIterationsToFindOptima = useSelector(
    (state) => state.numberOfIterationsToFindOptima
  );
  const adaptPermeateFlowDropThreshold = useSelector(
    (state) => state.adaptPermeateFlowDropThreshold
  );
  const adaptPressureDropThreshold = useSelector(
    (state) => state.adaptPressureDropThreshold
  );
  const adaptSaltPassageThreshold = useSelector(
    (state) => state.adaptSaltPassageThreshold
  );
  const simulationImproveAccuracy = useSelector(
    (state) => state.simulationImproveAccuracy
  );
  const installation_date = useSelector((state) => state.installation_date);
  const warranty = useSelector((state) => state.warranty);
  const app = useSelector((state) => state.app);
  const failureProbabilityThreshold = useSelector(
    (state) => state.failureProbabilityThreshold
  );

  const [exportAllData, setExportAllData] = useState({
    userCips: cips?.filter((item) => !item.is_tool_identified),
    cips,
    cleaningEffectiness,
    fouling,
    others: [
      {
        plantName,
        plantLocation,
        water_type,
        num_trains,
        tol_num_elements,
        is_dupont_element: is_dupont_element
          ? t("ValueStrings.yes")
          : t("ValueStrings.no"),
        dataset_name,
        ...(app === "ra" && {
          installation_date: installation_date,
          warranty: warranty,
        }),
        sel_train,
        sel_pass,
        sel_stage,
        sel_pressure_vessels,
        sel_element_involved,
        sel_element_type,
        flow,
        pressure,
        feed,
        feed_water_factor,
        permeate,
        feed_water_permeate_factor,
        temperature: `\u00B0${temperature}`,
        flux,
        volume,
        currency,
        mass,
        conversion_rate,
        engryPrice,
        cipAcidPrice,
        cipAlkaliPrice,
        cipWaterPrice,
        costofDownTime,
        additional_chemical_price,
        acid_used_per_cip,
        acid_cip_ph,
        acid_cip_temp,
        acid_cip_duration,
        alkali_used_per_cip,
        alkali_cip_ph,
        alkali_cip_temp,
        alkali_cip_duration,
        additional_chemical_per_cip,
        cip_solution_ph,
        cip_solution_temp,
        cip_solution_duration,
        clusterPoints,
        medianCurvePoints,
        maxRelativeDistance,
        permeateFlowDropThreshold,
        pressureDropThreshold,
        useSaltPassageChange: useSaltPassageChange
          ? t("ValueStrings.yes")
          : t("ValueStrings.no"),
        saltPassageIncreaseThreshold,
        minDaysBetweenCIPs,
        maxDaysBetweenCIPs,
        cipIdentificationResolution,
        minIdleDaysShutdown,
        maxStabilizationDaysAfterCIP,
        minStabilizationDaysAfterCIP,
        minPointsForCleaningEffectiveness,
        deafultStabilizationDaysAfterCIP,
        foulingAggressivenessFactor,
        numberOfIterationsToFindOptima,
        adaptPermeateFlowDropThreshold: adaptPermeateFlowDropThreshold
          ? t("ValueStrings.yes")
          : t("ValueStrings.no"),
        adaptPressureDropThreshold: adaptPressureDropThreshold
          ? t("ValueStrings.yes")
          : t("ValueStrings.no"),
        adaptSaltPassageThreshold: adaptSaltPassageThreshold
          ? t("ValueStrings.yes")
          : t("ValueStrings.no"),
        simulationImproveAccuracy: simulationImproveAccuracy
          ? t("ValueStrings.yes")
          : t("ValueStrings.no"),
        failureProbabilityThreshold,
      }, //keep the order in sync with OthersTableStrings
    ],
  });

  return exportAllData;
};

export default ExportAllData;
